import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DriveEventService {
token = 'eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiREVWIiwiZXhwIjoxNTU5NzMwMDM2LCJ1c2VySWQiOiIgIn0.JcTEsEQq-yaOQPGyKI_SBVTh7-jFVlKYyZkuBHgYC_0'
  constructor( private http: HttpClient) { }
   url=environment.driveDashboardUrl;
  //url='http://191.168.0.161:8080'
  getDriveEvent(){
   // console.log(this.http.get('../../../assets/data/drive.json'))
   return this.http.get('../../../assets/data/drive.json');
  }

  getDriveData(){
     // return this.http.get('../../../assets/data/drive1.json');
    return this.http.get(this.url+'/drive/dashboard',
    {
      headers : new HttpHeaders().append('token',
      localStorage.getItem('token'))
    });
  }

}


// "eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiREVWIiwiZXhwIjoxNTU5NDYxNzg5LCJ1c2VySWQiOiIgIn0.8jJcToWpC9cz4jPzUYrfguKOHdDOXpV2_YzFgVgssRE"